import React from 'react';
import PropTypes from 'prop-types';
import { CorporateContactJsonLd } from 'next-seo';

const CorporateContact = ({ corporateContactData }) => {
  const { url, logo, contactPoint } = corporateContactData;

  return (
    <CorporateContactJsonLd
      url={url}
      logo={logo}
      contactPoint={contactPoint}
    />
  );
};

CorporateContact.propTypes = {
  corporateContactData: PropTypes.shape({
    contactPoint: PropTypes.arrayOf(
      PropTypes.shape({
        areaServed: PropTypes.string,
        availableLanguage: PropTypes.arrayOf(PropTypes.string),
        contactOption: PropTypes.string,
        contactType: PropTypes.string,
        telephone: PropTypes.string,
      }),
    ),
    logo: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

export default CorporateContact;
